export const getRejectReason = (item) => {
  if (!item) return "";
  return (
    item.rejectReason ||
    item.rejectionReason ||
    item.reject_reason ||
    item.rejection_reason ||
    item.reason ||
    item.rejectNote ||
    item.reject_note ||
    ""
  );
};
